// import { removeToken } from '@/utils/auth'
// import router from '@/router'

export default {
  setUserInfo({
    commit
  }, user) {
    commit('SET_USERINFO', user)
  },
  setPlatParam({
    commit
  }, data) {
    commit('SET_PLATPARAM', data)
  },
  loginOut({
    commit
  }, data) {
    // removeToken()
    // localStorage.removeItem('tokenValue')
    // localStorage.removeItem('cdss_userInfos')
    // localStorage.removeItem('zq_userName')
    // console.log('-----------login---------')
    // // router.push({
    // //   path: '/login'
    // // })
  }
}
